import { combineReducers } from "redux";
import { experts } from "./expert/reducer";
import { categary } from "./categary/reducer";
import { master } from "./master/reducer";
import { posts } from "./posts/reducer";
import { filter } from "./filter/reducer";
import { profile } from "./profile/reducer";
import { membership } from "./membership/reducer";
import { job } from "./job/reducer";
import { contest } from "./contest/reducer";
import { project } from "./project/reducer";
import { chatandnotification } from "./chatandnotification/reducer";
import { team } from "./team/reducer";
import { umbrella } from "./umbrella/reducer";
import { hire } from "./hire/reducer";
import { ots } from "./ots/reducer";
import { buy } from "./buy/reducer";
import { sale } from "./sale/reducer";
import { rental } from "./rental/reducer";
import { auction } from "./auction/reducer";
import { mergers } from "./mergers/reducer";
import { cv } from "./cv/reducer";
import { wallet } from "./wallet/reducer";
import { calender } from "./calender/reducer";
import { common } from "./common/reducer";
import { settingsDetails } from "./Contacts/reducer";

const reducers = combineReducers({
  auction: auction,
  rental: rental,
  sale: sale,
  buy: buy,
  posts: posts,
  master: master,
  categary: categary,
  experts: experts,
  filter: filter,
  profile: profile,
  membership: membership,
  job: job,
  project: project,
  contest: contest,
  chatandnotification: chatandnotification,
  team: team,
  umbrella: umbrella,
  hire: hire,
  ots: ots,
  mergers: mergers,
  cv: cv,
  wallet: wallet,
  calender: calender,
  common: common,
  settingsDetails
});
export default reducers;
